import React from 'react';
import { View, Text, Pressable, StyleSheet } from 'react-native';
import OPComponent from '../op_component';
import { COLOR, THEME } from '../../../constants/styles';

const styles = StyleSheet.create({
  actionSheet: {
    position: 'absolute',
    backgroundColor: COLOR.altContrast,
    borderRadius: 30,
    bottom: 50,
    left: 20,
    right: 20,
    padding: 30,
    flexDirection: 'column',
    flex: 1,
  },
  option: {
    flex: 1,
    minHeight: 70,
    width: '100%',
    borderRadius: 150,
    backgroundColor: COLOR.emphasis,
    marginBottom: 20,
  },
  optionText: {
    ...THEME.textBold,
    textAlign: 'center',
    lineHeight: 70,
    height: 70,
    color: COLOR.contrast,
  },
});
class ActionSheet extends OPComponent {
  constructor(props) {
    super(props);
    console.log(`ActionSheet()`);

    this.state = {
      showActionSheet: false,
      options: [],
      callback: null,
      cancelButtonIndex: 0,
    };
  }

  showActionSheetWithOptions = (dict, callback) => {
    console.log(`we've been asked to show:`, dict);
    const { options, cancelButtonIndex } = dict;
    this.setState({
      showActionSheet: true,
      options,
      callback,
      cancelButtonIndex,
    });
  };

  closeActionSheet = () => {
    this.setState({
      showActionSheet: false,
      options: null,
      callback: null,
      cancelButtonIndex: null,
    });
  };

  render() {
    const { children } = this.props;
    return (
      <View style={THEME.container}>
        {children}
        {this.state.showActionSheet && (
          <View style={styles.actionSheet}>
            {this.state.options.map((option, idx) => (
              <View key={`option-${option}`} style={styles.option}>
                <Pressable
                  onPress={() => {
                    if (idx !== this.state.cancelButtonIndex) {
                      this.state.callback(idx);
                    }
                    this.closeActionSheet();
                  }}
                >
                  <Text style={styles.optionText}>{option}</Text>
                </Pressable>
              </View>
            ))}
          </View>
        )}
      </View>
    );
  }
}

export default ActionSheet;
